
import Vue from 'vue';
import App from './App.vue';
import router from '@/router/router'
import store from './store'
import Vuex from "vuex";

//import axios from 'axios'
import VueAxios from 'vue-axios'


import VueI18n from 'vue-i18n'  // 引入 Vue I18n
import zhTW from './i18n/zh'      // 存放中文語系檔
import en from './i18n/en'      // 存放英文語系檔

import 'bootstrap';
import ElemenUI from "element-ui";
import CoreuiVue from "@coreui/vue";
import "element-ui/lib/theme-chalk/index.css";

import { CSwitch, CButton, CEmitRootEvent, CTooltip } from "@coreui/vue";
import Select2 from 'v-select2-component';

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.component('Loading', Loading);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';

import VueBootstrap4Table from 'vue-bootstrap4-table'
import "@/assets/scss/_modal.scss";
import "@/assets/scss/backend/backend.scss";
import "@/assets/scss/backend/backend.css";
import "@/assets/scss/BackEndLayout/login.css";
import "@/assets/scss/BackEndLayout/login.scss";
import "@/assets/scss/listFront.scss";
import "@/assets/scss/personnel-Information-form/personnel-Information-form.scss";
import "@/assets/scss/personnel-Information-form/personnel-Information-form.css";
import "@/assets/scss/login.scss";

import "@/assets/scss/_table.scss"

import api from './interceptors/api'
//import axios from 'axios'
import currencyFilter from './filter/currency'
import NumericDirective from './directive/NumericDirective'
import submitButton from './components/Common/submit.vue'
Vue.config.productionTip = false;
Vue.use(VueI18n)
Vue.use(ElemenUI);
Vue.use(CoreuiVue);
Vue.use(Vuex);

Vue.use(VueAxios, api)

// 預設使用的語系
let currentLocale = 'zh-TW';

// 檢查 localStorage 是否已有保存使用者選用的語系資訊
if (sessionStorage.getItem('footmark-lang')) {
    currentLocale = sessionStorage.getItem('footmark-lang');
    store.commit('setLang', currentLocale);
} else {
    store.commit('setLang', currentLocale);
}
const i18n = new VueI18n({
    locale: currentLocale,
    messages: {
      'zh-TW': zhTW,
      'en': en
    }
});
Vue.component('DatePicker', DatePicker);
Vue.component('VueBootstrap4Table', VueBootstrap4Table);
Vue.component("CButton", CButton);
Vue.component('Select2', Select2);
Vue.component('submitButton', submitButton);
const currencyF0 = (value) => { return currencyFilter(value, 0 )};
const currencyF2 = (value) => { return currencyFilter(value, 2 )};
const currencyF3 = (value) => { return currencyFilter(value, 3 )};
const currencyF5 = (value) => { return currencyFilter(value, 5 )};
Vue.filter('currency', currencyF0);
Vue.filter('currencyF2', currencyF2);
Vue.filter('currencyF3', currencyF3);
Vue.filter('currencyF5', currencyF5);
Vue.directive("c-emit-root-event", CEmitRootEvent);
// 加上數值輸入卡控功能
Vue.directive('integer',NumericDirective);

//--定義 alert / confirm 顯示 dialog
import {shareMixin} from './mixin/share'
Vue.mixin(shareMixin);

new Vue({
    i18n,
    router,
    store,    
    render: h => h(App)
}).$mount('#app');
export default {
    components: {
        CSwitch, 
        CButton, 
    },
    directives: {
        "c-tooltip": CTooltip,
    },
}
